import React from "react";
import {message, Modal} from "antd";
import TooltipIcon from "../Boilerplate/TooltipIcon";
import PropTypes from "prop-types";

export class UnfollowButton extends React.Component {
  state = { disabled: false };

  handleClick = bid => {
    if (!this.state.disabled) {
      this.setState({ disabled: true });
      message.info('Unfollowing bid ' + bid.resource.name);
      this.props.onLeave && this.props.onLeave(bid.resource.id);
    }
  };

  confirmLeave = bid => {
    let handleWontBid = bid => {
      this.props.handleWontBid(bid);
      leave.destroy();
    };

    let leave = Modal.confirm({
      title: 'Are you sure you want to unfollow this bid?',
      content: <span>
        If you unfollow this bid, it will be removed from your list immediately. To regain access to this bid, you will need to be re-invited.<br/>
        Did you instead mean to <a onClick={() => handleWontBid(bid)}>mark yourself as 'Not Bidding'</a>?
      </span>,
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => this.handleClick(bid),
    })
  };

  render() {
    return <a key={this.props.fauxKey} onClick={() => this.confirmLeave(this.props.bid)}>
      <TooltipIcon title={this.props.title} type={!this.state.disabled ? this.props.type : 'loading'}
                   theme={!this.state.disabled ? 'filled' : ''} iconStyle={{ fontSize: 22 }}/>
    </a>;
  }
}

UnfollowButton.propTypes = {
  onLeave: PropTypes.func,
  handleWontBid: PropTypes.func,
  fauxKey: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/Bids/UnfollowButton.js